import { sectionLabelHtml } from '@paintscout/ui-business'

// Treat empty/whitespace-only HTML variants as empty so a no-op edit doesn't mark the quote dirty.
export const normalizeHtml = (html?: string | null): string => {
  const trimmed = (html ?? '').trim()
  return trimmed === '' || trimmed === '<p></p>' || trimmed === '<p><br></p>' || trimmed === '<br>' ? '' : trimmed
}

// The <p data-section-label="…"> line that `sectionLabelHtml` writes (SECTION_LABEL_ATTRIBUTE).
const SECTION_LABEL_PATTERN = /<p\s[^>]*data-section-label[^>]*>[\s\S]*?<\/p>/
const SECTION_LABEL_PATTERN_ALL = /<p\s[^>]*data-section-label[^>]*>[\s\S]*?<\/p>/g

/**
 * The content of the one Products editor (ENG-2106): the product description, then a locked
 * "Additional Work:" label line, then the additional-work products. An empty side gets a blank line
 * so the caret can reach it. Pass `additionalLabel: null` to leave the Additional Work section out.
 */
export function joinProductNotes(products: string, additional: string, additionalLabel: string | null): string {
  if (additionalLabel === null) {
    return products || ''
  }
  const before = normalizeHtml(products) || '<p></p>'
  const after = normalizeHtml(additional) || '<p></p>'
  return `${before}${sectionLabelHtml(additionalLabel)}${after}`
}

/**
 * Splits the Products editor's HTML back into its two notes, on the first section label. With no
 * label, everything is the product description and `additional` is null: leave that note as it is.
 */
export function splitProductNotes(html: string): { products: string; additional: string | null } {
  const match = SECTION_LABEL_PATTERN.exec(html)
  if (!match) {
    return { products: html, additional: null }
  }
  return {
    products: html.slice(0, match.index),
    // A pasted copy of the label must not end up saved as text.
    additional: html.slice(match.index + match[0].length).replaceAll(SECTION_LABEL_PATTERN_ALL, '')
  }
}
